import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const useTrainingsclubTerms = () => {
  const [terms, setTerms] = useState(null);
  const [error, setError] = useState(false);
  const load = () => { setError(false); api.get("/trainingsclub/terms").then(({ data }) => setTerms(data)).catch(() => setError(true)); };
  useEffect(() => { load(); }, []);
  return { terms, error, retry: load };
};

export const TrainingsclubTermsText = ({ terms, prefix = "tc-terms" }) => (
  <div data-testid={`${prefix}-text`} className="space-y-6 break-words" lang="de">
    {terms.sections.map((section) => <section key={section.number} data-testid={`${prefix}-section-${section.number}`}>
      <h3 data-testid={`${prefix}-heading-${section.number}`} className="font-semibold text-sm text-white mb-2">{section.number}. {section.heading}</h3>
      <p data-testid={`${prefix}-body-${section.number}`} className="text-neutral-300 text-sm leading-relaxed whitespace-pre-line">{section.body}</p>
    </section>)}
  </div>
);

export const AcademyTrainingsclubTerms = ({ state }) => {
  const { terms, error, retry } = state;
  if (error) return <div role="alert" data-testid="academy-tc-terms-error" className="text-red-400 text-sm">Die Trainingsclub-AGB konnten nicht geladen werden. <button type="button" data-testid="academy-tc-terms-retry" onClick={retry} className="underline">Erneut laden</button></div>;
  if (!terms) return <p data-testid="academy-tc-terms-loading">AGB werden geladen …</p>;
  return <><p className="text-neutral-400 text-sm mb-6" data-testid="academy-tc-terms-title">{terms.title} – {terms.subtitle}</p><TrainingsclubTermsText terms={terms} prefix="academy-tc-terms" /></>;
};

export const TrainingsclubTermsDialog = ({ open, onOpenChange, terms }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="tc-terms-dialog" overlayClassName="z-[80]" className="z-[81] bg-[#0A0A0A] border-[#ff0033]/30 text-white w-[calc(100%-2rem)] max-w-3xl max-h-[88dvh] flex flex-col gap-4 p-5 sm:p-7 overflow-hidden">
      <DialogTitle className="text-lg pr-6" data-testid="tc-terms-title">AGB und Teilnahmebedingungen</DialogTitle>
      <DialogDescription className="text-neutral-400 text-sm" data-testid="tc-terms-subtitle">Trainingsclub der Golf Coaching Academy Wendlingen</DialogDescription>
      <div className="overflow-y-auto min-h-0 pr-2" data-testid="tc-terms-scroll" tabIndex={0}>
        {terms && <TrainingsclubTermsText terms={terms} />}
      </div>
      <button type="button" data-testid="tc-terms-close-bottom" onClick={() => onOpenChange(false)} className="shrink-0 py-3 px-4 bg-[#ff0033] hover:bg-[#cc0029] transition-colors text-white">Zurück zur Mitgliedschaft</button>
    </DialogContent>
  </Dialog>
);